import { TOP_HEADER_HEIGHT, ICandidateJob } from '../../../common';
import { Grid, Theme, useAppSelector } from '../../../base';
import { JobCard } from './JobCard';
import { jobsSelectors } from '../../../actions';
import { useMediaQuery } from '@mui/material';
import PargodaLoading from '../../PargodaLoading';

const JobsGrid = () => {
    const candidatesJobs = useAppSelector(jobsSelectors.getCandidatesJobs);
    const isCandidatesJobsLoading = useAppSelector(
        jobsSelectors.getCandidatesJobsLoading
    );

    const isMobileSm = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('sm')
    );

    return (
        <Grid
            container
            rowSpacing={3}
            columnSpacing={isMobileSm ? 0 : 3}
            sx={{
                width: '100%',
                height: `calc(100vh - ${TOP_HEADER_HEIGHT}px)`,
                overflow: 'auto',
                justifyContent: {
                    xs: 'center',
                },
                paddingBottom: 3,
            }}
        >
            {isCandidatesJobsLoading ? (
                <PargodaLoading height={600} width={600} />
            ) : (
                candidatesJobs.map((job: ICandidateJob) => (
                    <Grid item key={job.id} maxWidth="100%">
                        <JobCard job={job} />
                    </Grid>
                ))
            )}
        </Grid>
    );
};

export default JobsGrid;
